import { isAllowedTrigger } from './OdigeoInteractions';

export const SessionStorageUtils = {
    getJSON(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowedTrigger('sessionStorage', key) ? JSON.parse(sessionStorage.getItem(key)) : null;
        } catch (err) {
            console.error(err);
            return null;
        }
    },

    setJSON(key, data) {
        try {
            if (isAllowedTrigger('sessionStorage', key)) {
                sessionStorage.setItem(key, JSON.stringify(data)); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            console.error(err);
        }
    },
    setValue(key, data) {
        try {
            if (isAllowedTrigger('sessionStorage', key)) {
                sessionStorage.setItem(key, data); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            console.error(err);
        }
    },
    getValue(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowedTrigger('sessionStorage', key) ? sessionStorage.getItem(key) : null;
        } catch (err) {
            console.error(err);
            return null;
        }
    },
};
